'use client';

var classes = {
  "title": "m_615af6c9",
  "header": "m_b5489c3c",
  "inner": "m_60c222c7",
  "content": "m_fd1ab0aa",
  "close": "m_606cb269",
  "body": "m_5df29311"
};
export { classes as default };